import { createCredentials } from './credentials.js';
/**
 * The default/global context.
 * @internal @hidden
 * @category Contexts
 */
export const defaultContext = {
    id: 0,
    root: '/',
    pwd: '/',
    credentials: createCredentials({ uid: 0, gid: 0 }),
    descriptors: new Map(),
    parent: null,
    children: [],
};
